import { ChargingSessionStatus } from '../../charging-sessions/types'

export enum MetricType {
  Cost = 'Cost',
  Energy = 'Energy',
}

export type ChartDateRangeView = 'day' | 'week' | 'month' | 'year'
export const chartDateRangeViews: ChartDateRangeView[] = ['day', 'week', 'month', 'year']

export enum DashboardFilterActionType {
  setWallbox = 'SET_WALLBOX',
  setAuthentication = 'SET_AUTHENTICATION',
  setStatus = 'SET_STATUS',
  dateRange = 'DATE_RANGE',
  clearAll = 'CLEAR_ALL',
}

export type DashboardFilterAction =
  | { type: DashboardFilterActionType.setWallbox; value: string[] }
  | { type: DashboardFilterActionType.setAuthentication; value: string[] }
  | { type: DashboardFilterActionType.setStatus; value: ChargingSessionStatus[] }
  | { type: DashboardFilterActionType.dateRange; value: { startDate: string; endDate: string; view: ChartDateRangeView } }
  | { type: DashboardFilterActionType.clearAll }

export type DashboardState = {
  filters: {
    wallboxId: string[]
    ocpiTokenIds: string[]
    statuses: ChargingSessionStatus[]
    dataRange: {
      startDate: string
      endDate: string
      view: ChartDateRangeView
    }
  }
}

export interface ChartDateRange {
  startDate: string
  endDate: string
  view: ChartDateRangeView
}

export const CUSTOM_TABLET_BREAKPOINT = 750
